import React, { useState } from 'react'
import { Box, Modal, Tabs } from '@mantine/core'
import { VectorSearchFilters, SearchFilter } from '../../../../lib/types'
import { CopyMatches } from './CopyMatches'
import { AddEditFilters } from './AddEditFilters'

type FiltersModalProps = {
  opened: boolean
  onClose: () => void
  selectedFilters: VectorSearchFilters
  setSelectedFilters: (filters: VectorSearchFilters) => void
  currency: string
  w?: number | string
  h?: number | string
}

export const FiltersModal = ({ opened, onClose, selectedFilters, setSelectedFilters, currency, w=1200, h=900 }: FiltersModalProps) => {
  const [updatedFilters, setUpdatedFilters] = useState<VectorSearchFilters>(selectedFilters)
  const [currentTab, setCurrentTab] = useState<string | null>('filters')

  return (
    <Modal centered opened={opened} onClose={onClose} h={h} closeOnClickOutside={false} style={{ overflow: 'hidden' }} size={w}>
      <Tabs value={currentTab} onChange={setCurrentTab} style={{ overflow: 'hidden' }} h={h}>
        <Tabs.List>
          <Tabs.Tab value='filters'>
            Add/Edit Filters
          </Tabs.Tab>
          <Tabs.Tab value='matches'>
            Copy Description From Matches
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="filters" h='95%'>
          <AddEditFilters
            updatedFilters={updatedFilters}
            setUpdatedFilters={setUpdatedFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            onClose={onClose}
            currency={currency}
          />
        </Tabs.Panel>
        <Tabs.Panel value="matches" h='95%'>
          <Box>
            <CopyMatches
              setCurrentTab={setCurrentTab}
              setUpdatedFilters={setUpdatedFilters}
            />
          </Box>
        </Tabs.Panel>
      </Tabs>
    </Modal>
  )
}
